var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingPage"},[_c('div',{staticClass:"inner"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa","size":"24","vertical":""}},[_vm._v("\n      正在为您跳转页面...\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }